import {Box, Grid, Typography} from "@mui/material";
import Countdown from "react-countdown";
import {theme} from "../../../../Tema";



export const useCuentaRegresiva = ({fecha = new Date().setTime(23), textoS=20}) => {


    const Reloj = () => {



        const renderer = ({days, hours, minutes, seconds, completed}) => {

            // return <span>{`${days}d-${hours}h-${minutes}m-${seconds}s`}</span>;

            if (completed) {
                return (

                    <Typography sx={{lineHeight: 1.2, fontWeight: 700, fontSize: textoS}} >
                        Atrazado
                    </Typography>

                )
            }

            if (fecha === -1){
                return (

                    <Typography sx={{lineHeight: 1.2, fontWeight: 700, fontSize: textoS}} >
                       Atrazado
                    </Typography>

                )
            }

            return (

                <Typography sx={{lineHeight: 1.2, fontWeight: 700, fontSize: textoS}} >
                    {`${days}D-${hours}h-${minutes}min`}
                </Typography>

            )

        };

        return (


            <Countdown
                daysInHours={true}
                date={fecha}
                renderer={renderer}
            />


        )
    }

    return {
        Reloj
    }

}